import { discordUrl } from "../../../enviroments";

import BarChartIcon from "@mui/icons-material/BarChart";
import AccountBalanceWalletIcon from "@mui/icons-material/AccountBalanceWallet";
import HomeRoundedIcon from "@mui/icons-material/HomeRounded";
import DnsRoundedIcon from "@mui/icons-material/DnsRounded";
import GroupIcon from "@mui/icons-material/Group";
import QuestionAnswerIcon from "@mui/icons-material/QuestionAnswer";
import RocketLaunchIcon from "@mui/icons-material/RocketLaunch";

interface LinkProps {
    label: string;
    url: string;
    icon: any;
    newWindow?: boolean;
}

export const Links: LinkProps[] = [
    { label: "home", url: "/", icon: <HomeRoundedIcon /> },
    {
        label: "poolInfo",
        url: "/pool-info",
        icon: <DnsRoundedIcon />,
    },
    {
        label: "miner_other",
        url: "/miners",
        icon: <GroupIcon />,
    },
    {
        label: "discord",
        url: discordUrl,
        icon: <QuestionAnswerIcon />,
        newWindow: true,
    },
];

export const NativeMenuLinks: LinkProps[] = [
    {
        label: "startMining",
        url: "/start-mining",
        icon: <RocketLaunchIcon />,
    },
    {
        label: "trading",
        url: "/trading-view",
        icon: <BarChartIcon />,
    },
    {
        label: "wallet",
        url: "https://signum.network/wallet",
        icon: <AccountBalanceWalletIcon />,
        newWindow: true,
    },
];
